import React, { useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import {
  isEmpty,
  showToast,
  validateEmail,
  validatePassword
} from '../../utils/AppHelper'
import { Link, useNavigate } from 'react-router-dom'
import { Grid, useMediaQuery, useTheme } from '@mui/material'
import serverData from '../../api/ServerData'
import CustomModal from '../../commonComponents/CustomModal'
import { setUserDetails } from '../../utils/LocalStorage'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../commonComponents/TextStyling'
import AppButton from '../../commonComponents/AppButton'
import ForgotPasswordModal from './ForgotPasswordModal'
import AppIcon from '../../commonComponents/AppIcon'
import appassets from '../../utils/appassets'
import PasswordPopperComponent from '../../commonComponents/PasswordPopperComponent'
import { ENV } from '../../ENV'

function Login () {
  const navigate = useNavigate()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [formError, setFormError] = useState({})
  const [modal, setModal] = useState({
    open: false,
    title: '',
    message: '',
    onClose: null
  })
  const [openForgotModal, setOpenForgotModal] = useState(false)

  function handleSubmit (event) {
    event.preventDefault()

    const error = {}

    if (isEmpty(email) || !validateEmail(email)) {
      error.email = 'Invalid email'
    }

    if (isEmpty(password)) {
      error.password = 'Password cannot be empty'
    } else if (password.length < 8) {
      error.password = 'Password should be 8 characters long'
    } else if (!validatePassword(password)) {
      error.password =
        'Password should contain at least a letter, number, and special character'
    }

    setFormError(error)

    if (Object.keys(error).length === 0) {
      setLoading(true)

      serverData.login(
        { email, password },
        result => {
          if (result.status) {
            setUserDetails(result.response)
            navigate(
              result.response.usertype === 'employer'
                ? '/employer/dashboard'
                : '/recruiter/dashboard'
            )

            // if (!result.response.isProfileCompleted) {
            //   navigate(
            //     result.response.usertype === 'employer'
            //       ? '/employer/editprofile'
            //       : '/recruiter/editprofile'
            //   )
            // } else {
            //   navigate(
            //     result.response.usertype === 'employer'
            //       ? '/employer/dashboard'
            //       : '/recruiter/dashboard'
            //   )
            // }
          } else {
            if (result.response.status === 'inactive') {
              setModal({
                open: true,
                title: `User account ${result.response.status}`,
                message: result.message,
                onClose: () => setModal({ open: false })
              })
            } else if (result.response.isEmailVerified === false) {
              setModal({
                open: true,
                title: 'Email verification pending',
                message: result.message,
                onClose: () => setModal({ open: false })
              })
            } else {
              showToast(result.message)
            }
          }

          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error?.statusText)
        }
      )
    }
  }

  return (
    <div
      style={{
        backgroundImage: `url(${appassets.signupBackground})`,
        height: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <Grid container style={{ paddingBottom: '16px' }}>
        <Grid
          item
          style={{ cursor: 'pointer' }}
          onClick={() => window.open(`${ENV.product_url}`, '__blank')}
        >
          <AppIcon
            style={{
              marginTop: matches ? '16px' : '24px', // Responsive margin
              marginLeft: matches ? '16px' : '72px', // Responsive margin
              width: matches ? '80px' : '139px'
            }}
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        textAlign={'center'}
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: matches ? '16px' : '0px' // Responsive padding
        }}
      >
        <Grid item xs={12}>
          <TextBold
            style={{
              fontSize: matches ? '28px' : '48px', // Responsive font size
              lineHeight: matches ? '1.2' : '60px' // Responsive line height
            }}
          >
            Welcome Back!
          </TextBold>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            padding: '0px',
            marginTop: '16px'
          }}
        >
          <TextRegular
            style={{
              fontSize: matches ? '14px' : '16px',
              lineHeight: '28px',
              color: theme.palette.text.disabled
            }}
          >
            To continue, enter your registered Email ID and Password.
          </TextRegular>
        </Grid>
      </Grid>

      <Container
        component='main'
        maxWidth='xl'
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: matches ? '16px' : '0px' // Responsive padding
        }}
      >
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: matches ? '100%' : '28rem' // Responsive width
          }}
        >
          <Grid
            container
            spacing={2}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              border: `1px solid ${theme.palette.border.main}`,
              backgroundColor: theme.palette.background.paper,
              borderRadius: '8px',
              padding: matches ? '1rem' : '1rem 0rem 0rem', // Responsive padding
              margin: matches ? '1rem 0rem' : '2rem 0rem 2rem 0rem' // Responsive margin
            }}
          >
            <Box
              component='form'
              onSubmit={handleSubmit}
              noValidate
              style={{
                width: matches ? '100%' : '88%' // Responsive width
              }}
            >
              <Grid item xs={12}>
                <div
                  style={{
                    margin: '16px 0px -16px 0px'
                  }}
                >
                  <TextBold
                    style={{
                      color: theme.palette.text.disabled
                    }}
                  >
                    Email
                  </TextBold>
                </div>

                <TextField
                  margin='normal'
                  required
                  fullWidth
                  id='email'
                  placeholder='Enter your email'
                  name='email'
                  autoComplete='email'
                  autoFocus
                  value={email}
                  onChange={event => {
                    var { value } = event.target
                    if (value.length < 50) {
                      setEmail(value)
                    }
                  }}
                  error={formError.email}
                  helperText={formError.email}
                />
              </Grid>

              <Grid item xs={12}>
                <PasswordPopperComponent
                  password={password}
                  setPassword={setPassword}
                  formError={formError.password}
                  isPopper={false}
                  title={'Password'}
                  page={'login'}
                />
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'left'
                }}
              >
                <Button
                  onClick={() => setOpenForgotModal(true)}
                  variant='text'
                  style={{
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px',
                    lineHeight: '48px'
                  }}
                >
                  Forget Password?
                </Button>
              </Grid>

              <Grid item xs={12}>
                <AppButton
                  type='submit'
                  onClick={handleSubmit}
                  name={'Login'}
                  sx={{
                    mt: 1,
                    mb: 2
                  }}
                  style={{
                    height: '48px'
                  }}
                  disabled={false}
                  loading={loading}
                />
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  fontSize: '12px',
                  lineHeight: '64px',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <TextRegular
                  style={{
                    color: theme.palette.text.disabled
                  }}
                >
                  Don't have an account?
                  <TextSemiBold
                    style={{
                      color: theme.palette.primary.main,
                      cursor: 'pointer'
                    }}
                    onClick={() => navigate('/signup')}
                  >
                    {' Sign Up '}
                  </TextSemiBold>
                  it’s FREE
                </TextRegular>
              </Grid>
            </Box>
          </Grid>
        </Box>

        <CustomModal data={modal} />

        {openForgotModal && (
          <ForgotPasswordModal
            onClose={message => {
              setOpenForgotModal(false)
              if (message) {
                setModal({
                  open: true,
                  title: `Email sent`,
                  message: message,
                  onClose: () => setModal({ open: false })
                })
              }
            }}
          />
        )}
      </Container>
    </div>
  )
}

export default Login
